import { useEvent, useStore } from 'effector-react'
import {
    $goodIds,
    $isAddressSelector,
    $isCitySelector,
    $isStockSelector,
    openStockForGoods,
    openStockSelectorWithBasketItems,
    toggleAddressSelector,
    toggleCitySelector,
    toggleStockSelector
} from 'src/features/shipment-selector/model'

export const useToggleStockSelector = () => useEvent(toggleStockSelector)
export const useIsStockSelector = () => useStore($isStockSelector)
export const useOpenStockSelectorWithBasketItems = () => useEvent(openStockSelectorWithBasketItems)
export const useOpenStockForGoods = () => useEvent(openStockForGoods)
export const useGoodIds = () => useStore($goodIds)
export const useToggleAddressSelector = () => useEvent(toggleAddressSelector)
export const useIsAddressSelector = () => useStore($isAddressSelector)
export const useToggleCitySelector = () => useEvent(toggleCitySelector)
export const useIsCitySelector = () => useStore($isCitySelector)
